<template>
  <v-menu
    content-class="custom_menu"
    :close-on-content-click="false"
    bottom
    offset-y
    nudge-bottom="15"
    nudge-left="270"
  >
    <v-btn slot="activator" icon>
      <svg style="width:24px;height:24px" viewBox="0 0 24 24">
        <path
          fill="#fff"
          d="M16,17H7V10.5C7,8 9,6 11.5,6C14,6 16,8 16,10.5M18,16V10.5C18,7.43 15.86,4.86 13,4.18V3.5A1.5,1.5 0 0,0 11.5,2A1.5,1.5 0 0,0 10,3.5V4.18C7.13,4.86 5,7.43 5,10.5V16L3,18V19H20V18M11.5,22A2,2 0 0,0 13.5,20H9.5A2,2 0 0,0 11.5,22Z"
        ></path>
      </svg>
      <span class="custom_badge">{{naoVistos.length}}</span>
    </v-btn>
    <v-layout class="notificacoes">
      <v-flex>
        <v-card class="panel">
          <v-toolbar style="background-color: #fff;box-shadow: #e0e0e0 1px 1px 1px 1px;">
            <v-toolbar-title
              class="grey-sm-title"
            >Novas notificações ({{naoVistos.length}}) Total: {{naoVistos.length + vistos.length}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom v-if="naoVistos.length > 0">
              <span
                slot="activator"
                style="font-size: 9px !important;cursor:pointer;"
                class="grey-sm-title"
                @click="marcarVisto(naoVistos, 'all')"
              >Visualizar todas</span>
              <span>Marcar todas notificações como lidas</span>
            </v-tooltip>
          </v-toolbar>
          <v-progress-linear
            color="teal"
            style="margin: 0;"
            v-if="this.loading"
            :indeterminate="true"
          ></v-progress-linear>
          <v-list v-if="!this.loading" two-line subheader>
            <v-list-tile
              v-for="(item,i) in setArray(this.naoVistos)"
              :key="item._id"
              avatar
              class="notificacao naoVista"
            >
              <v-list-tile-avatar>
                <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title
                  v-if="item.tipo !='zipFechamento'"
                >{{ item.tipo }} {{item.componente}}</v-list-tile-title>
                <v-list-tile-title v-else>{{item.componente}}</v-list-tile-title>
                <v-list-tile-sub-title v-if="item.tipo !='zipFechamento'">{{ item.desc }}</v-list-tile-sub-title>
                <v-list-tile-sub-title v-else>
                  <a
                    target="_blank"
                    :href="gerarLinkZIP(item.desc)"
                  >Clique para baixar!</a>
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>{{ new Date(item.dtReg).toLocaleDateString()}} - {{new Date(item.dtReg).toLocaleTimeString()}}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-tooltip bottom>
                  <v-btn slot="activator" icon ripple @click.native="marcarVisto(item, 'parse')">
                    <v-icon
                      class="grey lighten-1 white--text"
                      style="border-radius: 50%;font-size: 12px;padding: 2px;"
                    >check</v-icon>
                  </v-btn>
                  <span>Marcar como lida</span>
                </v-tooltip>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
              v-for="(item,i) in setArray(this.vistos)"
              :key="item._id"
              avatar
              class="notificacao"
            >
              <v-list-tile-avatar>
                <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
              </v-list-tile-avatar>

               <v-list-tile-content>
                <v-list-tile-title
                  v-if="item.tipo !='zipFechamento'"
                >{{ item.tipo }} {{item.componente}}</v-list-tile-title>
                <v-list-tile-title v-else>{{item.componente}}</v-list-tile-title>
                <v-list-tile-sub-title v-if="item.tipo !='zipFechamento'">{{ item.desc }}</v-list-tile-sub-title>
                <v-list-tile-sub-title v-else>
                  <a
                    target="_blank"
                    :href="gerarLinkZIP(item.desc)"
                  >Clique para baixar!</a>
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>{{ new Date(item.dtReg).toLocaleDateString()}} - {{new Date(item.dtReg).toLocaleTimeString()}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-layout
              align-center
              justify-center
              row
              fill-height
              class="grey-sm-title"
              style="height: 36px;margin-top: 9px;"
            >
              <span
                v-if="!msg || msg == ''"
                style="cursor:pointer;"
              >{{naoVistos.length == 0 && vistos.length == 0 ? 'Não há notificações.' : ''}}</span>
              <span v-else-if="msg && msg != ''" style="cursor:pointer; text-align: center;">{{msg}}</span>
              <span
                v-if="(!msg || msg == '') && empresa"
                @click="getNotificacoes()"
                style="cursor:pointer;"
              >Ver mais</span>
            </v-layout>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-menu>
</template>
<script>
import NotificacaoService from "@/domain/notificacoes/NotificacoesService.js";
export default {
  props: ["conta", "empresa"],
  data() {
    return {
      naoVistos: [],
      vistos: [],
      msg: "Selecione alguma empresa.",
      page: 2,
      loading: false
    };
  },
  watch: {
    "conta.notificacoes": function() {
      this.loading = false;
      if (this.conta) {
        this.msg = [];
        this.page = 2;
        if (this.conta.notificacoes) {
          if (this.conta.notificacoes.naoVistas) {
            this.naoVistos = this.conta.notificacoes.naoVistas;
          }
          if (this.conta.notificacoes.vistas) {
            this.vistos = this.conta.notificacoes.vistas;
          }
          if (
            this.conta.notificacoes ==
            "Notificações desativadas para esta empresa"
          ) {
            this.msg = this.conta.notificacoes;
            this.naoVistos = [];
            this.vistos = [];
          }
        } else {
          this.naoVistos = [];
          this.vistos = [];
        }
      }
    },
    empresa: function() {
      this.loading = false;
    }
  },
  methods: {
    gerarLinkZIP(desc){
      try{
        return `/download/fechamentoMensal?_link=${desc ? desc.split(':')[1] : ''}`.replace( /\s/g, '' );
      }catch(er){
        console.log(er);
        return "";
      }
    }, 
    getNotificacoes: function() {
      this.service = new NotificacaoService(this.$http);
      this.loading = true;
      this.service
        .getNotificacoesGeral(
          this.conta.id_usuario,
          this.empresa._id,
          this.page,
          10
        )
        .then(res => {
          if (res.ok) {
            this.naoVistos = this.naoVistos.concat(res.body.naoVistas);
            this.vistos = this.vistos.concat(res.body.vistas);
            if (res.body.naoVistas.length > 0 || res.body.vistas.length > 0) {
              this.page++;
            } else {
              this.msg =
                "Não há mais notificações no Motor Fiscal para esta empresa.";
            }
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
    setArray: function(array) {
      if (array && array.length) {
        array.forEach((item, i) => {
          if (item.tipo == "ultConsulta") {
            item.tipo = "Última consulta";
            item["icon"] = "check";
            item["iconClass"] = "green lighten-1 white--text";
          } else if (item.tipo == "notaCancelada") {
            item.tipo = "Nota cancelada";
            item["icon"] = "warning";
            item["iconClass"] = "warning lighten-1 white--text";
          } else if ((item.tipo = "zipFechamento")) {
            item["icon"] = "archive";
            item["iconClass"] = "green lighten-1 white--text";
          }
        });
        return array;
      }
    },
    marcarVisto: function(item, acao) {
      if (item) {
        let notifIds = [];
        if (acao == "parse") {
          notifIds.push(item._id);
        } else if (acao == "all") {
          item.forEach(notifi => {
            notifIds.push(notifi._id);
          });
        }

        this.loading = true;

        if (this.conta.id_usuario) {
          this.service = new NotificacaoService(this.$http);
          this.service.attVisto(notifIds, this.conta.id_usuario).then(resp => {
            //mandar att as notificações
            if (resp.ok) {
              this.conta.getNotificacoes = true;
            }
          });
        }
      }
    }
  }
};
</script>
<style scoped>
.notificacoes {
  width: 342px;
}

.grey-sm-title {
  font-size: 12px !important;
  color: rgb(119, 119, 119) !important;
  font-weight: 700 !important;
}
.custom_badge {
  position: absolute;
  top: -3px;
  right: 3px;
  background-color: #1976d2;
  padding: 1px 5px;
  border-radius: 50%;
  font-weight: 600;
  font-size: 10px;
}
.naoVista {
  background-color: #eceeff94;
}

.panel {
  max-height: 475px;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/notificacoes/Notificacoes.vue